<ng-container *ngIf="abierto">
    <div class="divisor16"></div>
    <div>
        <div [hidden]="consulta" class="evaluacion">
            <div class="row">
                <div class="col-lg-12" style="padding: 0px;">
                    <section>
                        <div *ngFor="let competencia of listapreguntas; index as index">

                            <!-- Competencia -->
                            <div class="row">
                                <div class="col-12 evaluacion__preguntas__competencia" style="box-shadow: 0 0 10px -6px {{competencia.color}}; background: {{competencia.color}}">
                                    <div class="{{competencia.colortext}} evaluacion__preguntas__competencia__titulo">
                                        <span>{{competencia.nombre}}</span>
                                    </div>
                                </div>
                            </div>

                            <div *ngFor="let criterio of competencia.listacriterio; index as index">

                                <!-- criterio -->
                                <div class="evaluacion__preguntas__criterio">
                                    <i class="fa fa-circle" aria-hidden="true" style="color: {{competencia.color}}"></i>
                                    <span class="evaluacion__preguntas__criterio__texto">{{criterio.nombre}}</span>
                                </div>

                                <!-- preguntas-->
                                <div >
                                    <div *ngFor="let pregunta of criterio.listapreguntas; index as index">

                                        <!-- Pregunta -->
                                        <div class="evaluacion__preguntas__pregunta">
                                            <span style="background-color: {{pregunta.color}};">{{index+ 1}}.-{{pregunta.pregunta}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>
</ng-container>